// src/components/Navbar.js
import React from 'react';
import { Input, Menu } from 'antd';
import { SettingOutlined, BellOutlined, LogoutOutlined } from '@ant-design/icons';
import { logout, keycloak } from '../auth/keycloak';
import NavTestbedSwitcher from './NavTestbedSwitcher';
import { isAdminFromGroups } from '../auth/groupToTestbed';
import './Navbar.css';

const { Search } = Input;

const menuItems = [
  { key: 'settings', icon: <SettingOutlined />, label: '' },
  { key: 'notifications', icon: <BellOutlined />, label: '' },
  { key: 'logout', icon: <LogoutOutlined />, label: '' },
];

const Navbar = () => {
  const groups = keycloak?.tokenParsed?.groups || [];
  const isAdmin = isAdminFromGroups(groups);

  return (
    <div className="navbar">
      <div className="logo">
        <img src={require('../images/logo.png')} alt="Logo" />
        <h2 className="m-0">COGNIFOG</h2>
      </div>

      <div className="search-bar">
        <Search placeholder="Search..." className="input-primary" />
      </div>

      <div className="menu" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <NavTestbedSwitcher isAdmin={isAdmin} /> {/* ← only renders for admin */}
        <Menu
          mode="horizontal"
          items={menuItems}
          selectable={false}
          className="navbar-menu"
          onClick={({ key }) => { if (key === 'logout') logout(); }}
        />
      </div>
    </div>
  );
};

export default Navbar;
